import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SharedCalGuide from "../../SharedCalGuide";
import $ from "jquery";
import CallAPI from "../../../../services/apiCalls";
import useUserStore from "../../../../utils/storeApp";
//import { Tree } from "primereact/tree";
import CheckboxTree from "react-checkbox-tree";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import * as treeFunc from "../../../../services/ReportsTree";

let search = {
  Name: null,
  NameFilter: null,
  Email: null,
  EmailFilter: null,
  StartDate: null,
  EndDate: null,
  OrganizationId: null,
  OrganizationName: null,
  OrganizationList: null,
  ReportedUserEvent: null,
  DateFilter: "ForwardingStartDate",
  IncludeSubOrgs: false,
  DomainName: null,
  DomainId: null,
  VendorName: null,
  VendorId: null,
  MessageForwardingStatus: null,
  MaxSize: null,
  MinSize: null,
  City: null,
  State: null,
};
const SearchMessageForwarding = () => {
  const navigate = useNavigate();
  const { userToken, SetSharedObject, sharedObject, userRole, userSession } =
    useUserStore((state) => ({
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
      sharedObject: state.sharedObject,
      userRole: state.userRole,
      userSession: state.userSession,
    }));
  const [date, setDate] = useState(null);
  const [startdate, setStartDate] = useState(null);
  const [enddate, setEndDate] = useState(null);
  const [minDate, setMinDate] = useState(new Date());
  const [maxDate, setMaxDate] = useState(new Date());
  const [processing, SetProcessing] = useState(false);
  const [domainObj, SetDomainObj] = useState([]);
  const [orgBulkObj, SetOrgBulkObj] = useState([]);
  const [answers, setAnswers] = useState(search);
  const [custObj, SetCustObj] = useState([]);
  const [submFlag, setSubmFlag] = useState(false);
  const setAnswer = async (questionId, answer) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };
  const [domainName, setDomainName] = useState(null);
  const [domainId, setDomainId] = useState(null);
  const [organizationName, setOrganizationName] = useState(null);
  const [organizationId, setOrganizationId] = useState(null);
  const [vendorName, seVendorName] = useState(null);
  const [selectedKeys, setSelectedKeys] = useState(null);
  const [newFileName, setNewFileName] = useState("");
  const [submInputFlag, setSubmitInputFlag] = useState(false);
  const [orgRequired, setOrgRequired] = useState(false);
  const [checked, setChecked] = useState([]);
  const [expanded, setExpanded] = useState([]);
  const [orgTreeFilter, setOrgTreeFilter] = useState("");
  const [filteredOrgTree, setFilteredOrgTree] = useState([]);
  useEffect(() => {
    setSubmFlag(false);
    $("#startDate")
      .datepicker()
      .on("changeDate", function (e) {
        setNewDate(e.date);
        setStartDate(new Date(e.date));
        $("#startDate").datepicker("hide");
        let dt = e.date;
        let max = new Date(dt.getFullYear(), dt.getMonth() + 3, dt.getDate());
        $("#endDate").datepicker("setDate", new Date());
        $("#endDate").datepicker("show");
      });
    $("#endDate")
      .datepicker()
      .on("changeDate", function (e) {
        setDate(new Date(e.date));
        setEndDate(new Date(e.date));
        $("#endDate").datepicker("hide");
      });
    $("#startDate").datepicker("setDate", getLastWeek(true));
    $("#endDate").datepicker("setDate", new Date(getLastWeek()));
    setEndDate(new Date());
    setStartDate(new Date(getLastWeek(true)));
    if (userRole === "SES ADMINISTRATOR") {
      getDomains();
    } else {
      let dmId = parseInt(userSession.domain_id);
      setDomainId(dmId);
      setAnswers({
        ...answers,
        OrganizationId: userSession.org_id,
        DomainId: userSession.domain_id,
      });
      if (!isEmpty(sharedObject.UserMsgyType))
        getOrgByVendors(userSession.vendor_id + "~List~" + dmId);
    }
  }, [sharedObject.UserMsgyType]);
  function isEmpty(value) {
    let x =
      value == null || (typeof value === "string" && value.trim().length === 0);
    return x;
  }
  const getLastWeek = (flag) => {
    let today = new Date();
    let month = flag ? today.getMonth() - 3 : today.getMonth();
    let lastWeek = new Date(today.getFullYear(), month, today.getDate());
    return lastWeek;
  };
  const setNewDate = (selected) => {
    let dt = new Date(selected);
    let today = new Date();
    setMinDate(dt);
    let max = new Date(dt.getFullYear(), dt.getMonth() + 3, dt.getDate());
    setMaxDate(max);
    if (max > today) {
      setMaxDate(today);
    }
    //$("#endDate").datepicker("setEndDate", max);
    $("#endDate").datepicker("setDate", null);
    setEndDate(null);
  };
  const getDomains = async () => {
    if (userRole !== "SES ADMINISTRATOR") {
      await { ...answers, VendorId: userSession.vendor_id };
    }
    SetProcessing(true);
    SetOrgBulkObj([]);
    let call = "/customers/GetUserDomains";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      const obj = res.data.data;
      SetDomainObj(obj);
      if (userRole !== "SES ADMINISTRATOR" && obj.length === 1) {
        await { ...answers, DomainId: userSession.domain_id };
        getOrgByVendors(`${userSession.vendor_id}~List`);
      }
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };

  const getMessages = async () => {
    setSubmFlag(true);
    let call =
      "/reports/MessageForwarding?searchPhrase=''&sortDir=SentDate&sortBy=SentDate";
    let StartDate = $("#startDate").datepicker("getFormattedDate");
    let EndDate = $("#endDate").datepicker("getFormattedDate");
    if (sharedObject.UserMsgyType === "bulk") {
      if (checked.length === 0) {
        setOrgRequired(true);
        return;
      }
      const temp = [];
      checked.forEach((elem) => {
        let e = elem.split("~");
        let o = {
          Key: parseInt(e[0]),
          Value: e[1],
        };
        temp.push(o);
      });
      SetOrgBulkObj(temp);
    }
    if (!organizationId && sharedObject.UserMsgyType === "reg") {
      setOrgRequired(true);
      return;
    } else if (!startdate) {
      document.getElementById("startDate").scrollIntoView();
      document.getElementById("startDate").focus();
      return;
    } else if (!enddate) {
      document.getElementById("endDate").scrollIntoView();
      document.getElementById("endDate").focus();
      return;
    }
    let finalSearch = {
      ...answers,
      DomainName: domainName,
      DomainId: domainId,
      OrganizationName: organizationName,
      VendorName: vendorName,
      OrganizationId: organizationId,
      StartDate: new Date(StartDate),
      EndDate: new Date(EndDate),
    };
    let refObj = { ...finalSearch };
    if (sharedObject.UserMsgyType === "bulk") {
      $("#SearchMessageForwarding").modal("hide");
      $("#InputDownloadModalSearchRec").modal("show");
      setSubmitInputFlag(false);
      return;
    } else {
      if (answers.IncludeSubOrgs) {
        const subOrgList = await getSubOrgList(
          organizationId,
          organizationName
        );
        if (subOrgList === "error") {
          console.log("Unable to get sub org list.");
          SetProcessing(false);
          return;
        }
        const newArray = subOrgList.filter((obj) => obj.Value !== "Root");
        refObj = { ...finalSearch, OrgList: JSON.stringify(newArray) };
      }
    }
    SetProcessing(true);
    SetSharedObject("messageForwarding", finalSearch);

    const res = await CallAPI(call, refObj, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      // setOrganizationId(null);
      // SetCustObj([]);
      // SetOrgObject([]);
      // setSubmitInputFlag(false);
      // setOrgRequired(false);
      // getDomains();
      SetSharedObject("UserActiviySearch", res.data.data);
      $("#SearchMessageForwarding").modal("show");
      setAnswer("BaseDomainId", "");
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };

  const getVendorsByDomain = async (id) => {
    let dom = id.split("~");
    setDomainId(dom[0]);
    setDomainName(dom[1]);
    await setAnswer("DomainId", dom[0]);
    if (userRole !== "SES ADMINISTRATOR") {
      getOrgByVendors(`${userSession.vendor_id}~List~${dom[0]}`);
      return;
    }
    SetProcessing(true);
    let call = "/admin/getVendorsByDomain?domainId=" + dom[0];
    const res = await CallAPI(call, null, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let temp = [];
      if (res.data.data) {
        for (let el of res.data.data) {
          el.show = true;
          temp.push(el);
        }
      }
      SetCustObj(temp);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
    setAnswer("BaseDomainId", id);
  };
  const filterVendors = (val) => {
    const tmp = [];
    if (val.length > 1) {
      custObj?.map((el) => {
        let elem = el.text;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      custObj?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetCustObj(tmp);
  };
  const [orgObject, SetOrgObject] = useState([]);
  const getOrgByVendors = async (val) => {
    let domId = val.split("~");
    seVendorName(domId[1]);
    const domainNr = domId[2] ? domId[2] : domainId;
    await setAnswer("VendorId", parseInt(domId[0]));
    SetProcessing(true);
    let call = null;
    if (sharedObject.UserMsgyType === "reg") {
      call =
        "/admin/getOrganizationsByVendorAndDomainId?vendorID=" +
        parseInt(domId[0]) +
        "&domainId=" +
        domainNr;
    } else if (sharedObject.UserMsgyType === "bulk") {
      let org = answers.OrganizationId
        ? parseInt(answers.OrganizationId)
        : userRole !== "SES ADMINISTRATOR"
        ? parseInt(userSession.org_id)
        : "";
      let vendor = domId[0] ? parseInt(domId[0]) : "";
      let domain = answers.DomainId
        ? parseInt(answers.DomainId)
        : userRole !== "SES ADMINISTRATOR"
        ? parseInt(userSession.domain_id)
        : "";
      call =
        "/organization/GetOrganizationTree?orgId=" +
        org +
        "&vendorId=" +
        vendor +
        "&domainId=" +
        domain;
    }

    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let obj = null;
      if (sharedObject.UserMsgyType === "reg") {
        obj = res.data.data;
        let temp = [];
        if (obj) {
          for (let el of obj) {
            el.show = true;
            temp.push(el);
          }
        }
        SetOrgObject(temp);
      } else if (sharedObject.UserMsgyType === "bulk") {
        obj = res.data.data.value?.orgNode;
        if (obj) {
          let o = treeFunc.treeObj(obj);
          SetOrgObject(o);
        }
      }
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
    SetProcessing(false);
  };
  const filterOrganiations = (val) => {
    const tmp = [];
    if (val.length > 1) {
      orgObject?.map((el) => {
        let elem = el.text;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      orgObject?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetOrgObject(tmp);
  };
  const getSubOrgList = async (parentId, parentName) => {
    SetProcessing(true);
    let model = { ParentOrganizationId: parentId };
    let call = "/organization/OrgSearchEngine";
    const res = await CallAPI(call, model, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let arr = res.data.data;
      let newArr = [];
      let parentVal = { name: parentName, value: parentId, show: true };
      newArr.push(parentVal);
      for (var i = 0; i < arr.length; i++) {
        var val = { text: arr[i].name, value: arr[i].id, show: true };
        newArr.push(val);
      }
      return newArr;
    } else {
      return "error";
    }
  };
  const QueueDownloadSearch = async () => {
    setSubmitInputFlag(true);
    if (newFileName === "") {
      return;
    }
    let StartDate = $("#startDate").datepicker("getFormattedDate");
    let EndDate = $("#endDate").datepicker("getFormattedDate");
    let obj = {
      ...answers,
      DomainName: domainName,
      DomainId: domainId,
      OrganizationName: organizationName,
      VendorName: vendorName,
      OrganizationId: null,
      StartDate: new Date(StartDate),
      EndDate: new Date(EndDate),
    };

    const newArray = orgBulkObj.filter((obj) => obj.Value !== "Root");
    let refObj = { ...obj, OrgList: JSON.stringify(newArray) };
    SetProcessing(true);
    let call =
      "/reports/ExportSentMessagesStatus?sortBy=SentDate&sortDir=SentDate&fileName=" +
      newFileName +
      "&reportType=3";
    const res = await CallAPI(call, refObj, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      SetCustObj([]);
      SetOrgObject([]);
      setAnswer("BaseDomainId", "");
      setSubmitInputFlag(false);
      setOrgRequired(false);
      $("#InputDownloadModalSearchRec").modal("hide");
      $("#downloadProgressModal").modal("show");
    } else if (res.status === "SERVERERROR") {
      let msg = res.message;
      let str = "<div>";
      str += msg + "</div>";
      SetProcessing(false);
    }
  };
  const getTreeOrg = (e) => {
    const obj = e.value;
    if (obj && Object.keys(obj).length > 0) {
      setOrgRequired(false);
    }
    setSelectedKeys(e.value);
  };
  useEffect(() => {
    if (orgTreeFilter.length > 1) {
      const filtered = filterTree(orgObject, orgTreeFilter);
      setFilteredOrgTree(filtered);
    } else {
      setFilteredOrgTree(orgObject);
    }
  }, [orgTreeFilter, orgObject]);

  const filterTree = (nodes, filterText) => {
    return nodes
      .map((node) => {
        if (
          node.label.toLowerCase().includes(filterText.toLowerCase()) ||
          (node.children && filterTree(node.children, filterText).length > 0)
        ) {
          return {
            ...node,
            children: node.children
              ? filterTree(node.children, filterText)
              : [],
          };
        }
        return null;
      })
      .filter(Boolean);
  };
  return (
    <div className="SearchUserActivity">
      <div
        className="modal fade"
        id="SearchMessageForwarding"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="UserActivitySearch"
        aria-hidden="false"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <div
                className="modal-title spacer-inline text-size3"
                id="myModalLabel"
              >
                {sharedObject.UserMsgyType === "reg" ? (
                  "Search"
                ) : (
                  <div
                    className="modal-title spacer-inline text-size3"
                    id="myModalLabel"
                  >
                    Download
                    <div className="text-size6 line-s1">Big Data</div>
                  </div>
                )}
              </div>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={(e) => {
                  $("#SearchMessageForwarding").modal("hide");
                  if (userRole === "SES ADMINISTRATOR") SetOrgObject([]);
                  SetCustObj([]);
                  setSubmitInputFlag(false);
                  setAnswer("BaseDomainId", "");
                  setOrgRequired(false);
                }}
              >
                <span aria-hidden="false">&times;</span>
              </button>
            </div>
            <form>
              <div className="modal-body">
                <div className="modal-content-body container">
                  {userRole === "SES ADMINISTRATOR" && domainObj.length > 1 ? (
                    <div className="field-wrapper">
                      <label for="DomainId">Domain</label>
                      <select
                        className="form-control"
                        name="DomainId"
                        value={answers.BaseDomainId}
                        onChange={(el) => {
                          if (el.target.value !== "") {
                            SetOrgObject([]);
                            getVendorsByDomain(el.target.value);
                          }
                        }}
                      >
                        <option value="">Select Domain</option>
                        {domainObj?.map((el) => (
                          <option
                            key={el.value}
                            value={el.value + "~" + el.text}
                          >
                            {el.text}
                          </option>
                        ))}
                      </select>
                    </div>
                  ) : null}
                  {userRole === "SES ADMINISTRATOR" ? (
                    <div className="field-wrapper">
                      <label for="customer">Customer</label>
                      <span className="filter-container dg-clr spacer-margin8">
                        <input
                          className="form-control filter-sm"
                          type="search"
                          placeholder="Filter"
                          onChange={(el) => filterVendors(el.target.value)}
                        />
                      </span>
                      <select
                        size="4"
                        className="form-control"
                        name="VendorName"
                        id="VendorName"
                        value={answers?.VendorVal}
                        onChange={(el) => {
                          if (el.target.value !== "")
                            getOrgByVendors(el.target.value);
                        }}
                      >
                        <option value="">Select Customer</option>
                        {custObj?.map((el) => {
                          if (el.show)
                            return (
                              <option
                                key={el.value}
                                value={el.value + "~" + el.text}
                              >
                                {el.text}
                              </option>
                            );
                        })}
                      </select>
                    </div>
                  ) : null}
                  {/*<div className="descript-container">*/}
                  {/*  Select an organization to begin your search.*/}
                  {/*</div>*/}
                  {/*Organization*/}
                  <div className="field-wrapper">
                    <label for="Org">Organization</label>
                    <i className="bi bi-asterisk rd-clr"></i>
                    {sharedObject.UserMsgyType === "reg" ? (
                      <div className="filter-container dg-clr spacer-margin8">
                        <input
                          className="form-control filter-sm"
                          type="search"
                          placeholder="Filter"
                          onChange={(el) => filterOrganiations(el.target.value)}
                        />
                      </div>
                    ) : null}
                    {orgObject.length === 0 ? (
                      <div className="watermark-wrapper sp-margin16">
                        No Results
                      </div>
                    ) : sharedObject.UserMsgyType === "reg" ? (
                      <select
                        className="form-control"
                        size="4"
                        name="OrganizationId"
                        Id="OrganizationId"
                        value={answers?.Org}
                        onChange={(el) => {
                          let val = el.target.value;
                          if (val !== "") {
                            setOrgRequired(false);
                            let domId = val.split("-");
                            setOrganizationName(domId[1]);
                            setOrganizationId(domId[0]);
                            setAnswer("Org", val);
                          }
                        }}
                      >
                        <option value="">Select Organization</option>
                        {orgObject?.map((el) => {
                          if (el.show)
                            return (
                              <option
                                key={el.value}
                                value={el.value + "-" + el.text}
                              >
                                {el.text}
                              </option>
                            );
                        })}
                      </select>
                    ) : (
                      // <Tree
                      //   value={orgObject}
                      //   selectionMode="checkbox"
                      //   selectionKeys={selectedKeys}
                      //   onSelectionChange={(e) => getTreeOrg(e)}
                      //   className="w-full md:w-30rem"
                      // />
                      <div>
                        <span className="treefilter-wrapper filter-container dg-clr spacer-margin8">
                          <input
                            type="text"
                            className="form-control filter-sm pr-4 pos-1"
                            placeholder="Filter"
                            value={orgTreeFilter}
                            onChange={(e) => setOrgTreeFilter(e.target.value)}
                          />
                          {orgTreeFilter && (
                            <button
                              type="button"
                              onClick={() => setOrgTreeFilter("")}
                              className="clear-button"
                            >
                              <i className="bi bi-x"></i>
                            </button>
                          )}
                        </span>
                        <CheckboxTree
                          nodes={filteredOrgTree}
                          checked={checked}
                          expanded={expanded}
                          onCheck={(checked) => setChecked(checked)}
                          onExpand={(expanded) => setExpanded(expanded)}
                          noCascade={true}
                          showExpandAll={true}
                        />
                      </div>
                    )}
                    {submFlag && orgRequired ? (
                      <div
                        Id="OrganizationAlert"
                        className="alert alert-danger"
                      >
                        Required!
                      </div>
                    ) : null}
                  </div>
                  {sharedObject.UserMsgyType === "reg" ? (
                    <div className="field-wrapper">
                      <input
                        className="form-control spacer-margin5"
                        type="checkbox"
                        value={answers.IncludeSubOrgs}
                        onChange={(el) => {
                          setAnswer("IncludeSubOrgs", el.target.checked);
                        }}
                      />
                      <span for="OutNetwork" className="label-sub">
                        Include Sub Organizations
                      </span>
                    </div>
                  ) : null}
                  {/* Filter By */}
                  <div className="field-wrapper">
                    <label for="DateFilter">Filter By</label>
                    <select
                      id="DateFilter"
                      className="form-control "
                      value={answers.DateFilter}
                      onChange={(el) => {
                        setAnswer("DateFilter", el.target.value);
                      }}
                    >
                      <option value="">Select</option>
                      <option value="ForwardingStartDate">
                        Forwarding Start Date
                      </option>
                      <option value="ForwardingEndDate">
                        Forwarding End Date
                      </option>
                    </select>
                  </div>
                  <div className="field-wrapper">
                    <label for="Status">Status</label>
                    <select
                      id="Status"
                      className="form-control"
                      value={answers.MessageForwardingStatus}
                      onChange={(el) => {
                        setAnswer("MessageForwardingStatus", el.target.value);
                      }}
                    >
                      <option value="">Select</option>
                      <option value="0">Pending</option>
                      <option value="1">Active</option>
                      <option value="2">Failed</option>
                    </select>
                  </div>
                  {/* Calendar */}
                  <div className="field-wrapper">
                    <div className="spacer-margin5 spacer-inline w-md2 v-top">
                      <label for="StartDate">Start Date</label>
                      <i className="bi bi-asterisk rd-clr"></i>
                      <div
                        className="input-group date"
                        data-provide="datepicker"
                        id="startDate"
                        data-date-end-date="1d"
                      >
                        <input
                          type="text"
                          className="form-control"
                          name="StartDate"
                          //   value={date}
                        />
                        <div className="input-group-append">
                          <span className="input-group-text" id="">
                            <i className="fas fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                      {submFlag && !startdate ? (
                        <div className="alert alert-danger">Required!</div>
                      ) : null}
                    </div>

                    {/*End Date*/}
                    <div className="spacer-inline w-md2 v-top">
                      <label for="EndDate">End Date</label>{" "}
                      <i className="bi bi-asterisk rd-clr"></i>
                      <div
                        className="input-group date end-date"
                        data-provide="datepicker"
                        id="endDate"
                      >
                        <input
                          type="text"
                          className="form-control"
                          name="EndDate"
                          //   value={endDate}
                        />
                        <div className="input-group-append">
                          <span className="input-group-text" id="">
                            <i className="fas fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                      {submFlag && !enddate ? (
                        <div className="alert alert-danger">Required!</div>
                      ) : null}
                    </div>
                    {/*<div className="text-size1 sp-margin13">*/}
                    {/*  <a*/}
                    {/*    href="#collapseCal"*/}
                    {/*    data-toggle="collapse"*/}
                    {/*    aria-expanded="false"*/}
                    {/*    aria-controls="collapseCal"*/}
                    {/*  >*/}
                    {/*    {" "}*/}
                    {/*    More Info{" "}*/}
                    {/*  </a>*/}
                    {/*</div>*/}
                  </div>
                  <SharedCalGuide />
                  {/* Search by Name */}
                  <div className="field-wrapper">
                    <div className="spacer-margin5 spacer-inline w-md2">
                      <label for="">Name</label>
                      <select
                        className="form-control w-md2"
                        name=""
                        value={answers.NameFilter}
                        onChange={(el) => {
                          setAnswer("NameFilter", el.target.value);
                        }}
                      >
                        <option value="">Search By</option>
                        <option value="Username">Username</option>
                        <option value="First Name">First Name</option>
                        <option value="Last Name">Last Name</option>
                      </select>
                    </div>
                    <input
                      className="form-control spacer-inline w-md2"
                      placeholder="Enter Name"
                      value={answers.Name}
                      onChange={(el) => {
                        setAnswer("Name", el.target.value);
                      }}
                    />
                  </div>
                  {/* Search by Direct Email  EmailFilter */}
                  <div className="field-wrapper">
                    <div className="spacer-margin5 spacer-inline w-md2">
                      <label for="">Email</label>
                      <select
                        className="form-control w-md2"
                        name=""
                        value={answers.EmailFilter}
                        onChange={(el) => {
                          setAnswer("EmailFilter", el.target.value);
                        }}
                      >
                        <option value="">Search By</option>
                        <option value="DirectEmail">Direct Email</option>
                        <option value="ForwardEmail">Forward Email</option>
                      </select>
                    </div>
                    <input
                      className="form-control spacer-inline w-md2"
                      value={answers.Email}
                      placeholder="Enter Email"
                      onChange={(el) => {
                        setAnswer("Email", el.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={(e) => getMessages()}
                >
                  {sharedObject.UserMsgyType === "reg" ? "Search" : "Continue"}
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={(e) => {
                    $("#SearchMessageForwarding").modal("hide");
                    if (userRole === "SES ADMINISTRATOR") SetOrgObject([]);
                    SetCustObj([]);
                    setSubmitInputFlag(false);
                    setAnswer("BaseDomainId", "");
                    setOrgRequired(false);
                  }}
                >
                  Cancel
                </button>
                {/*Processing Spinner*/}
                {processing ? <div className="loading"></div> : null}
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="InputDownloadModalSearchRec"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="CreateNewFilename"
        aria-hidden="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title " id="myModalLabel">
                Download Filename
              </div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="false">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="modal-content-body">
                <div className="descript-container">
                  Enter a new name to identify your download file once it has
                  been queued in the download status page.
                </div>
                <div className="modal-content-form">
                  <label for="NewFileName">Create a new file name</label>
                  <input
                    className="form-control"
                    name="NewFileName"
                    value={newFileName}
                    onChange={(el) => setNewFileName(el.target.value)}
                  />
                  {submInputFlag && newFileName === "" ? (
                    <div className="alert alert-danger">Required!</div>
                  ) : null}

                  <div className="field-wrapper sp-margin3 descript-container">
                    Downloading may take several minutes to hours depending on
                    the number of records and timeframe of the report.
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={QueueDownloadSearch}
              >
                {" "}
                Queue Download{" "}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-dismiss="modal"
              >
                {" "}
                Close{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SearchMessageForwarding.defaultProps = {};

export default SearchMessageForwarding;
